module.exports = ".scroll-v {\n  max-height: 80vh;\n  overflow-y: auto !important;\n  overflow-x: auto !important; }\n\n.form-incomplete {\n  border-color: #e87b86 !important; }\n\n.form-incomplete .card-header {\n    background: #e87b86 !important; }\n\n.form-complete {\n  border-color: #a3e2b1 !important; }\n\n.form-complete .card-header {\n    background: #a3e2b1 !important; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/refactor-dynamic-form/refactor-dynamic-form.component.scss
// module id = ./src/app/shared/refactor-dynamic-form/refactor-dynamic-form.component.scss
// module chunks = main